module.exports = __webpack_public_path__ + "static/image2-ab091a009ee6e27c31ed2a44af453aab.jpg";